import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function PageHero({ eyebrow, title, sub, image }) {
  return (
    <section className="relative overflow-hidden pb-16 pt-36 sm:pb-20 sm:pt-44">
      {image && (
        <>
          <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/85 to-ink" />
        </>
      )}
      {!image && (
        <div className="pointer-events-none absolute -top-32 start-1/4 h-[420px] w-[420px] rounded-full bg-gold/10 blur-[140px]" />
      )}
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="eyebrow mb-4">{eyebrow}</motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="max-w-3xl text-3xl font-extrabold leading-[1.3] tracking-tight text-white sm:text-4xl lg:text-5xl"
        >
          {title}
        </motion.h1>
        {sub && (
          <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }} className="mt-5 max-w-2xl text-base leading-8 text-mist sm:text-lg">
            {sub}
          </motion.p>
        )}
      </div>
      <ChevronDown className="pointer-events-none absolute bottom-4 start-1/2 -translate-x-1/2 animate-bounce text-gold/50" />
    </section>
  );
}
